import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useStore } from '@/utils/store';
import { format, subDays, isSameDay } from 'date-fns';
import { es, enUS } from 'date-fns/locale';

export const selectWeeklyData = (state) => {
  const now = new Date();
  const days = [];
  for (let i = 6; i >= 0; i--) {
    const day = subDays(now, i);
    const dayExpenses = state.transactions
      .filter((t) => t.type === 'expense' && isSameDay(new Date(t.date + 'T00:00:00'), day))
      .reduce((sum, t) => sum + t.amount, 0);
    days.push({ day, amount: dayExpenses });
  }
  return days;
};

export default function WeeklyTrendChart() {
  const { t, i18n } = useTranslation();
  const weeklyData = useStore(selectWeeklyData);
  const locale = i18n.language === 'es' ? es : enUS;

  const data = useMemo(() =>
    weeklyData.map((d) => ({
      name: format(d.day, 'EEE', { locale }),
      [t('dashboard.expenses')]: d.amount,
    })),
    [weeklyData, locale, t]
  );

  return (
    <div className="card">
      <h2 className="font-semibold text-gray-900 dark:text-white mb-4">
        {t('dashboard.weeklyTrend')}
      </h2>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis dataKey="name" tick={{ fontSize: 12 }} stroke="#9ca3af" />
          <YAxis tick={{ fontSize: 12 }} stroke="#9ca3af" />
          <Tooltip
            contentStyle={{
              border: '1px solid #e5e7eb',
              borderRadius: '12px',
              fontSize: '12px',
            }}
          />
          <Bar dataKey={t('dashboard.expenses')} fill="#6366f1" radius={[6, 6, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
